<template>
    <div>
        <div class="card mb-5 mb-3">
            <div class="card-header">
                <h3 class="card-title flex-row"><i class="fa fa-list"></i> <span class="card-label fs-3 ms-1">Quản lý
                        đường dây nóng</span></h3>
            </div>
            <div class="card-body">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                        <label>Tên:</label>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-input clearable placeholder="Tên đường dây nóng..." v-model="search.cTen" />
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                        <label>SĐT:</label>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-input clearable placeholder="Đường dây nóng..." v-model="search.cSoDienThoai" />
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                        <label>Trạng thái:</label>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-select placeholder="Tất cả" v-model="search.nTinhTrang">
                                    <el-option label="Tất cả" value="-1" selected></el-option>
                                    <el-option label="Hoạt động" value="1" selected></el-option>
                                    <el-option label="Đã xóa" value="0" selected></el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                        <label>Loại:</label>
                        <el-row :gutter="10">
                            <el-col :xs="20" :sm="22" :md="20" :lg="20" :xl="22">
                                <el-select placeholder="Tất cả" v-model="search.cDanhMuc">
                                    <el-option label="Tất cả" value="" selected></el-option>
                                    <el-option label="Khẩn cấp" value="Khẩn cấp" selected></el-option>
                                    <el-option label="Đời sống xã hội" value="Đời sống xã hội" selected></el-option>
                                </el-select>
                            </el-col>
                            <el-col :xs="4" :sm="2" :md="4" :lg="4" :xl="2">
                                <el-button plain type="primary" title="Tìm kiếm" @click="handleFindPage"><i
                                        class="fa fa-search"></i></el-button>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
        </div>

        <div class="card data-table mb-5 mb-xl-10">
            <div class="card-header py-3">
                <div class="body-function">
                    <div class="col-md-6">
                        <el-button plain type="primary" outline native-type="submit" @click="handleOpenAdd"
                            data-bs-toggle="modal" data-bs-target="#modal_hotline">
                            <span class="btn-inner--icon"><i class="fas fa-plus"></i></span>
                            <span class="btn-inner--text">&nbsp;Thêm đường dây nóng</span>
                        </el-button>
                    </div>
                    <!-- <div class="col-md-6" style="text-align:right">
              <el-button plain icon="el-icon-refresh" size="small" style="margin-right:30px" title="Đồng bộ" type="warning" @click=""
                v-loading.fullscreen.lock="isLoading"></el-button>
            </div> -->
                </div>
            </div>
            <div class="card-body">
                <div class="col-md-12 tbl">
                    <el-table :data="tableData.content" header-row-class-name="thead-light" style="height: 100%"
                        height="100%" fit stripe highlight-current-row>
                        <el-table-column prop="nMaDuongDayNong" label="Mã" width="100" align="center"></el-table-column>
                        <el-table-column prop="cTen" label="Tên đường dây nóng" min-width="150" header-align="center">

                        </el-table-column>
                        <el-table-column prop="cSoDienThoai" label="Đường dây nóng" align="center" width="150">
                            <template #default="scope">
                                {{ scope.row.cSoDienThoai }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="cDanhMuc" label="Loại" width="150" align="center">
                            <!--  <template #default="scope">
                                <el-tag type="danger" effect="dark" v-if="scope.row.cDanhMuc == 'Khan cap'"
                                    :size="size">Khẩn cấp</el-tag>
                                <el-tag type="success" effect="dark" v-if="scope.row.cDanhMuc == 'Doi song xa hoi'"
                                    :size="size">Đời sống xã hội</el-tag>
                            </template> -->
                        </el-table-column>
                        <el-table-column prop="dNgayTao" label="Ngày tạo" width="120">
                            <template #default="scope">
                                <span v-if="scope.row.dNgayTao">{{
                                    momentDate(scope.row.dNgayTao)
                                }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="" label="Trạng thái" width="120" align="center">
                            <template #default="scope">
                                <el-tag type="success" v-if="scope.row.nTinhTrang == 1" size="small">Hoạt Động</el-tag>
                                <el-tag type="danger" v-if="scope.row.nTinhTrang == 0" size="small">Đã xóa</el-tag>
                            </template>
                        </el-table-column>
                        <!-- Button hành động -->
                        <el-table-column width="150" label="Hành động" align="center">
                            <template #default="scope">

                                <el-button plain type="primary" :disabled="scope.row.nTinhTrang == 0"
                                    @click="handleOpenEdit(scope.row)" data-bs-toggle="modal"
                                    data-bs-target="#modal_hotline">
                                    <span class="btn-inner--icon"><i class="fas fa-edit"></i></span>
                                </el-button>

                                <el-button plain type="danger" :disabled="scope.row.nTinhTrang == 0"
                                    v-loading.fullscreen.lock="isLoading" @click="handleDelete(scope.row)">
                                    <span class="btn-inner--icon"><i class="fas fa-trash"></i></span>
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="col-12 py-2 pagination" style="justify-content: end">
                <el-pagination @size-change="handleChangePageSize" @current-change="handleChangePageNum"
                    :current-page.sync="tableData.pageNum" :page-sizes="[5, 10, 20, 30, 40]"
                    :page-size="tableData.pageSize" layout="total, sizes, prev, pager, next, jumper"
                    :total="tableData.totalSize">
                </el-pagination>
            </div>
        </div>

        <div class="modal fade" id="modal_hotline" ref="hotlineModalRef" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered mw-650px">
                <div class="modal-content">
                    <!--begin::Modal header-->
                    <div class="modal-header" id="modal_hotline_header">
                        <!--begin::Modal title-->
                        <h2 class="fw-bolder">{{ !operation ? "Thêm đường dây nóng" : "Cập nhật đường dây nóng" }}</h2>
                        <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal"
                            @click="handleClose">
                            <span class="svg-icon svg-icon-1">
                                <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
                            </span>
                        </div>
                        <!--end::Close-->
                    </div>
                    <!--end::Modal header-->
                    <div class="modal-body">
                        <el-form :model="formData" :rules="rules" ref="formData" label-width="150px"
                            class=" d-flex flex-column">
                            <el-form-item label="Tên đường dây" prop="cTen">
                                <el-input v-model="formData.cTen" />
                            </el-form-item><el-form-item label="Địa chỉ" prop="cDiaChi">
                                <el-input v-model="formData.cDiaChi" />
                            </el-form-item>
                            <el-form-item label="Loại đường dây" prop="cDanhMuc">
                                <el-select placeholder="Chọn loại đường dây" v-model="formData.cDanhMuc"
                                    style="width: 30%;">
                                    <el-option label="Khẩn cấp" value="Khẩn cấp"></el-option>
                                    <el-option label="Đời sống xã hội" value="Đời sống xã hội"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="Đường dây" prop="cSoDienThoai" >
                                <el-input v-model="formData.cSoDienThoai" />
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="modal-footer">
                        <div class="btn-group">
                            <el-button plain v-if="!operation" type="primary" v-loading.fullscreen.lock="isLoading"
                                @click="handleSave">Thêm</el-button>
                            <el-button plain v-if="operation" type="primary" v-loading.fullscreen.lock="isLoading"
                                @click="handleSave">Lưu</el-button>
                            <el-button plain type="danger" @click="handleClose">Thoát</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Hotlines } from "@/store/enums/StoreEnums";
import moment from "moment";
import { useStore } from "vuex";
import { hideModal } from "@/core/helpers/dom";
import { ElMessage } from "element-plus";
export default {
    name: 'hotline',
    data() {
        var legalPrefix = ["32", "39", "55", "56", "58", "59", "70", "76", "79", "80", "86", "88", "89", "90", "94", "96", "99"]
        var landlinePrefix3 =["212","213","214","215","216","218","203","204","205","206","207","208","209","210","219","211","220","221","222","225","226","227","228","229","232","233","234","237","238","239","235","236","252","255","256","257","258","259","260","261","262","263","269","251","254","271","274","276","270","272","273","275","277","290","291","292","293","294","296","297","299"]
        var landlinePrefix2 =["28","24"]
        var validateMobile = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("Xin vui lòng nhập số điện thoại"));
            } else {
                if (value.substr(0, 2) == "84") {
                    if (value.length != 11) {
                        callback(new Error("Số điện thoại phải bao gồm 11 ký số"));
                    } else if (!legalPrefix.includes(value.substr(2, 2)) || !landlinePrefix3.includes(value.substr(2, 3)) || !landlinePrefix2.includes(value.substr(2, 2))) {
                        callback(new Error("Đầu số phải thuộc mã vùng điện thoại hoặc đầu số di động hợp lệ"));
                    } else {
                        callback()
                    }
                } else if (value.substr(0, 1) == "0") {
                    if (value.length != 10) {
                        callback(new Error("Số điện thoại phải bao gồm 10 ký số"));
                    } else if (!legalPrefix.includes(value.substr(1, 2)) || !landlinePrefix3.includes(value.substr(1, 3)) || !landlinePrefix2.includes(value.substr(1, 2))) {
                        callback(new Error("Đầu số phải thuộc mã vùng điện thoại hoặc đầu số di động hợp lệ"));
                    } else {
                        callback()
                    }
                } else {
                    callback(new Error("Đầu số phải là 84 hoặc 0"));
                }
            }
        };
        return {
            search: {
                cTen: "",
                cSoDienThoai: "",
                cDanhMuc: "",
                nTinhTrang: "-1",
            },
            pageRequest: {
                columnFilters: {},
                pageSize: 30,
                pageNum: 1
            },
            formData: {
                cTen: "",
                cSoDienThoai: "",
                cDanhMuc: "",
                cDiaChi: ""
            },
            rules: {
                cTen: [{ required: true, message: "Xin vui lòng điền tên đường dây", trigger: "blur" }],
                cSoDienThoai: [
                    { required: true, message: "Xin vui lòng điền số điện thoại", trigger: "blur" },
                    { min: 10, message: "Xin vui lòng điền ít nhất 10 số", trigger: "blur" },
                    //{ type: 'number', message: "Xin vui lòng chỉ điền chữ số", trigger: "blur" }
                    /* { validator: validateMobile, trigger: "blur" } */
                ],
                cDanhMuc: [{ required: true, message: "Xin vui lòng chọn loại đường dây", trigger: "blur" }],
                cDiaChi: [{ required: true, message: "Xin vui lòng nhập địa chỉ", trigger: "blur" }],
            },
            tableData: {
                content: [{}]
            },
            isLoading: false,
            modalVisible: false,
            operation: false,
            iframeURL: "",
            openIframe: false,
            isSearchLoading: false,
            store: useStore()
        }
    },
    methods: {
        handleChangePageNum(val) {
            this.pageRequest.pageNum = val
            this.handleFindPage()
        },
        handleChangePageSize(val) {
            this.pageRequest.pageSize = val
            this.handleFindPage()
        },
        handleOpenAdd() {
            this.$refs.formData.resetFields()
            this.modalVisible = true
            this.operation = false
            this.formData = {}
        },
        handleOpenEdit(val) {
            this.$refs.formData.resetFields()
            this.modalVisible = true
            this.operation = true
            this.formData = Object.assign({}, val)
        },
        handleClose() {
            this.$refs.formData.resetFields()
            this.modalVisible = false
            hideModal(this.$refs.hotlineModalRef)
        },
        handleDelete(val) {
            this.$confirm("Bạn có muốn xóa đường dây nóng này không?", "Xác nhận", {
                confirmButtonText: "Xác nhận",
                cancelButtonText: "Hủy",
                type: "warning",
            })
                .then(() => {
                    this.store.dispatch(Hotlines.deleteHotlinesById, val.nMaDuongDayNong).then(res => {
                        if (res.code == 200) {
                            ElMessage({ message: "Xóa đường dây nóng thành công", type: "success" });
                            this.handleFindPage()
                        } else {
                            ElMessage({ message: res.msg, type: "error" });
                        }
                    }).catch((error) => {
                        ElMessage({ message: "Xóa đường dây nóng thất bại", type: "error" });
                    })
                }).catch(() => {

                })
        },
        handleFindPage() {
            this.pageRequest.columnFilters = {
                cTen: { value: this.search.cTen },
                cSoDienThoai: { value: this.search.cSoDienThoai },
                cDanhMuc: { value: this.search.cDanhMuc },
                nTinhTrang: { value: this.search.nTinhTrang },
            }
            this.store.dispatch(Hotlines.findPageHotlines, this.pageRequest).then(res => {
                if (res.code == 200) {
                    this.tableData = res.data
                }
            }).catch((error) => {
                ElMessage({ message: "Tìm đường dây thất bại", type: "error" });
            })
        },
        handleSave() {
            this.$refs.formData.validate((valid) => {
                if (valid)
                    this.$confirm("Bạn có muốn lưu đường dây này không?", "Xác nhận", {
                        confirmButtonText: "Xác nhận",
                        cancelButtonText: "Hủy",
                        type: "warning",
                    })
                        .then(() => {
                            const data = {

                                "cTen": this.formData.cTen,
                                "cSoDienThoai": this.formData.cSoDienThoai,
                                "cDanhMuc": this.formData.cDanhMuc,
                                "nTinhTrang": 1,
                                "cDiaChi": this.formData.cDiaChi
                            }
                            if (this.operation) {
                                console.log(this.formData.cDanhMuc)
                                this.store.dispatch(Hotlines.updateHotlines, { ...data, id: this.formData.nMaDuongDayNong }).then(res => {
                                    if (res.code == 200) {
                                        ElMessage({ message: "Cập nhật đường dây thành công", type: "success" });
                                        this.handleClose()
                                        this.handleFindPage()
                                    }
                                    else {
                                        ElMessage({ message: res.msg, type: "error" });
                                    }
                                }).catch((error) => {
                                    ElMessage({ message: "Cập nhật đường dây nóng thất bại", type: "error" });
                                })
                            } else {
                                this.store.dispatch(Hotlines.saveHotlines, data).then(res => {
                                    if (res.code == 200) {
                                        ElMessage({ message: "Thêm đường dây thành công", type: "success" });
                                        this.handleClose()
                                        this.handleFindPage()
                                    }
                                    else {
                                        ElMessage({ message: res.msg, type: "error" });
                                    }
                                }).catch((error) => {
                                    ElMessage({ message: "Thêm đường dây nóng thất bại", type: "error" });
                                })
                            }
                        }).catch(() => {

                        })
            })
        },
        momentDate(val) {
            return val ? moment(val).format("DD/MM/YYYY") : ""
        }
    },
    mounted() {
        this.handleFindPage()
    }
};
</script>
<style lang="scss"></style>